/**
 * Checks if the radius unit is miles.
 * @param {String} radiusUnit - Radius unit to check
 * @returns {Boolean} - True if unit is miles.
 */
export function isRadiusUnitMiles(radiusUnit) {
  const lowerCase = radiusUnit.toLowerCase();

  return lowerCase === 'mi' || lowerCase === 'miles';
}
